/**
 * Browser-owned canonical wire view, using the portable-save asset normalizer.
 * Local history may retain exact pre-edit display URLs. The wire and divergence
 * hash must describe their durable pb-asset identities, including an Undo.
 * The Worker never imports this module or rewrites HTML to reproduce the view.
 */
import {
  canonicalizeAssetBackedMediaHTML,
  canonicalizeAssetBackedMediaInState
} from './asset-html.js';
import { stateHashOf } from './collab-protocol.js';

export function canonicalCollabState(state, options) {
  const clone = structuredClone(state);
  canonicalizeAssetBackedMediaInState(clone, options);
  return clone;
}

export function canonicalCollabStateHashOf(state, options) {
  return stateHashOf(canonicalCollabState(state, options));
}

function canonicalizeValue(path, value, options) {
  if (value == null) return value;
  if (/\.(?:html|originalHtml)$/.test(path) && typeof value === 'string') {
    return canonicalizeAssetBackedMediaHTML(value, options);
  }
  let wrapper;
  if (path === 'pages' && Array.isArray(value)) wrapper = { pages: value };
  else if (/^pages\.\d+$/.test(path)) wrapper = { pages: [value] };
  else if (/^pages\.\d+\.sections$/.test(path) && Array.isArray(value))
    wrapper = { pages: [{ sections: value }] };
  else if (
    /^pages\.\d+\.sections\.\d+$/.test(path) ||
    /^sharedSections\.(navigation|footer)$/.test(path)
  ) {
    wrapper = { pages: [{ sections: [value] }] };
  } else if (path === 'sharedSections') wrapper = { sharedSections: value };
  if (wrapper) canonicalizeAssetBackedMediaInState(wrapper, options);
  return value;
}

export function canonicalCollabFrame(frame, options) {
  const clone = structuredClone(frame);
  if (clone.t === 'seed') {
    clone.state = canonicalCollabState(clone.state, options);
    delete clone.state.identityRepairLocalOrigin;
    clone.stateHash = stateHashOf(clone.state);
  } else if (clone.t === 'op') {
    for (const patch of clone.forward || []) {
      if (patch.op === 'replace') patch.value = canonicalizeValue(patch.path, patch.value, options);
      else if (patch.op === 'insert') {
        if (patch.path === 'pages') patch.item = canonicalizeValue('pages.0', patch.item, options);
        else if (/^pages\.\d+\.sections$/.test(patch.path)) {
          patch.item = canonicalizeValue(`${patch.path}.0`, patch.item, options);
        }
      }
    }
  }
  return clone;
}
